export default __webpack_public_path__ + "static/puertoraiz-balthazaurus-scroll-6b013865654f9973a8216901e5ee2ca5.gif";